import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import workoutSlice from '../features/add_workout/workoutSlice';
import authenticationSlice from '../features/authentication/authenticationSlice';

export const store = configureStore({
  reducer: {
    Workout:workoutSlice,
    Login:authenticationSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
